module.exports = __webpack_public_path__ + "img/rule-title@2x.0f6c6090.png";